var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-markdown',{attrs:{"source":_vm.mdText}})
}
var staticRenderFns = []

export { render, staticRenderFns }